import { render, staticRenderFns } from "./apiJewelItemList.vue?vue&type=template&id=00aff734&scoped=true&"
import script from "./apiJewelItemList.vue?vue&type=script&lang=js&"
export * from "./apiJewelItemList.vue?vue&type=script&lang=js&"
import style0 from "./apiJewelItemList.vue?vue&type=style&index=0&id=00aff734&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00aff734",
  null
  
)

export default component.exports